unit Essentials.Web.RequiredFields.Editor;

interface

uses
  {$IFNDEF PAS2JS}
  Winapi.Windows, Winapi.Messages,
  {$ENDIF}
  System.SysUtils, {$IFNDEF PAS2JS}System.Variants,{$ENDIF} System.Classes, Vcl.Graphics,
  Vcl.Controls, Vcl.Forms, Vcl.Dialogs, WEBLib.Forms, WebForm.Core, Data.DB, WEBLib.DB,
  WEBLib.Lists, WEBLib.Grids, WEBLib.DBCtrls, WEBLib.Controls, WEBLib.Dialogs,
  Vcl.StdCtrls, WEBLib.StdCtrls, XData.Web.Dataset, JS, Grid.Plugins, Types, WebLib.ExtCtrls, Web,
  WEBLib.WebCtrls;

type
  TEssentialsRequiredFieldEditor = class(TCoreWebForm)
    lbPaginationInfo: TLabel;
    AddButton: TButton;
    cbPageSize: TComboBox;
    DeleteConfirmationMsg: TMessageDlg;
    EssentialsTable: TDBTableControl;
    lcPaginator: TListControl;
    DataSource: TDataSource;
    procedure AddButtonClick(Sender: TObject);
    procedure cbPageSizeChange(Sender: TObject);
    procedure DataSourceDataChange(Sender: TObject; Field: TField);
    procedure EssentialsTableGetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string;
      AElement: TJSHTMLElementRecord);
    procedure WebFormCreate(Sender: TObject);
  private
    { Private declarations }
    FIdField: string;
    FGridPlugin: TGridPlugin;
    procedure RefreshControls(aShow: Boolean);
    [Async]
    procedure Save; async;
    [Async]
    procedure DeleteRecord(ARecordId: string); async;
    [Async]
    procedure AddRecord; async;
    procedure AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement);
    function GetDeleteMsg: string;
  protected
    { Public declarations }
    procedure SetDataSet(aDataSet:TXdataWebDataset);
  protected procedure LoadDFMValues; override; end;

var
  EssentialsRequiredFieldEditor: TEssentialsRequiredFieldEditor;

implementation

uses Essentials.Web.Shared, SMX.Web.Layout.Utils, SMX.webcore.Types,
Essentials.Web.RequiredFields.EditValueForm;

{$R *.dfm}

procedure TEssentialsRequiredFieldEditor.AddButtonClick(Sender: TObject);
begin
  inherited;
  AddRecord;
end;

procedure TEssentialsRequiredFieldEditor.AddRecord; {$IFDEF PAS2JS}async;{$ENDIF}
var
  AForm: TRequiredFieldsEditValue;
begin
  AForm := TRequiredFieldsEditValue.Create(Self);
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    Await(TRequiredFieldsEditValue, AForm.Load());
    DataSource.DataSet.Insert;
    AForm.SetDataSources(DataSource.DataSet);
    AForm.LoadEntityList;
    AForm.EditMode := Add;

    if Await(TModalResult, AForm.Execute) = mrOK then
    begin
      // Ensure dataset is still in insert/edit state before posting
      if DataSource.DataSet.State in [dsInsert, dsEdit] then
      begin
        DataSource.DataSet.FieldByName('EntityClassName').AsString := AForm.EntitySelector.Value;
        DataSource.DataSet.FieldByName('FieldName').AsString := AForm.FieldSelector.Value;
        DataSource.DataSet.Post;
        Await(Save);
      end;
    end
    else
    begin
      // Cancel was clicked, cancel the insert
      if DataSource.DataSet.State in [dsInsert, dsEdit] then
        DataSource.DataSet.Cancel;
    end;
  finally
    FreeAndNil(AForm);
  end;
end;

procedure TEssentialsRequiredFieldEditor.AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement);
  procedure DeleteClick(Sender: TObject);
  begin
    DeleteRecord(ARecordId);
  end;

var
  Span: THTMLSpan;
begin
  Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-trash', 'Delete');
  Span.OnClick := @DeleteClick;
end;

procedure TEssentialsRequiredFieldEditor.cbPageSizeChange(Sender: TObject);
begin
  inherited;
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

procedure TEssentialsRequiredFieldEditor.DataSourceDataChange(Sender: TObject;
  Field: TField);
begin
  inherited;
  AddButton.Enabled := DataSource.DataSet.Active;
end;

procedure TEssentialsRequiredFieldEditor.DeleteRecord(ARecordId: string); {$IFDEF PAS2JS}async;{$ENDIF}
var {DeleteRecord}
  foundRecord: Boolean;
  EntityClassName, FieldName: string;
begin
  foundRecord := DataSource.Dataset.Locate(FIdField, ARecordId, []);

  if foundRecord and (Await(TModalResult, DeleteConfirmationMsg.ShowDialog(GetDeleteMsg, mtConfirmation, [mbYes, mbNo])) = mrYes) then
  begin
    // Get the entity and field name before deleting to clear cache
    EntityClassName := DataSource.DataSet.FieldByName('EntityClassName').AsString;
    FieldName := DataSource.DataSet.FieldByName('FieldName').AsString;
    
    DataSource.DataSet.Edit;
    DataSource.DataSet.Delete;
    Await(TResolveResults, TXDataWebDataset(DataSource.DataSet).ApplyUpdatesAsync);
    
    // Clear the cache for this specific field
    EssentialsManager.RequiredFieldsManager.RemoveFromCache(
      EssentialsManager.RequiredFieldsManager.CacheKey(EntityClassName, FieldName));
  end;
end;

procedure TEssentialsRequiredFieldEditor.EssentialsTableGetCellChildren(
  Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: string;
begin
  if ARow = 0 then
    Exit;

  if EssentialsTable.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := DataSource.DataSet.FieldByName(FIdField).AsString;

    if RecordId <> '' then
      AddRowActions(RecordId, AElement.Element)
    else
      AElement.Element.textContent := 'Loading...';
  end;
end;

function TEssentialsRequiredFieldEditor.GetDeleteMsg: string;
var
  value: string;
begin
  value := DataSource.Dataset.FieldByName('FieldName').AsString;
  Result := Format(DELETE_CONFIRMATION_SCHEMA, [QuotedStr(value)]);
end;

procedure TEssentialsRequiredFieldEditor.RefreshControls(aShow: Boolean);
begin
  lcPaginator.Visible := aShow;
  lbPaginationInfo.Visible := aShow;
  cbPageSize.Visible := aShow;
end;

procedure TEssentialsRequiredFieldEditor.Save; {$IFDEF PAS2JS}async;{$ENDIF}
begin
  Await(Boolean, EssentialsManager.RequiredFieldsManager.SaveChanges);
end;

procedure TEssentialsRequiredFieldEditor.SetDataSet(aDataSet: TXdataWebDataset);
begin
  DataSource.DataSet := aDataSet;
  AddButton.Enabled := DataSource.DataSet.Active;
end;

procedure TEssentialsRequiredFieldEditor.WebFormCreate(Sender: TObject);
begin
  inherited;
  FIdField := 'Id';
  SetDataSet(EssentialsManager.RequiredFieldsManager.RequiredFieldsDataset);
  FGridPlugin := TGridPlugin.Create(EssentialsTable, EssentialsManager.RequiredFieldsManager.RequiredFieldsDataset, lcPaginator, lbPaginationInfo,
      TSortPair.Create(1, sdAsc));
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  RefreshControls(False);
end;

procedure TEssentialsRequiredFieldEditor.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('essentials.requiredfields.PageInfo');
  AddButton := TButton.Create('essentials.requiredfields.add.button');
  cbPageSize := TComboBox.Create('essentials.requiredfields.PageSizeSelect');
  DeleteConfirmationMsg := TMessageDlg.Create('DeleteConfirmationMsg');
  EssentialsTable := TDBTableControl.Create('esssentials.requiredfields.table');
  lcPaginator := TListControl.Create('essentials.requiredfields.Pagination');
  DataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  AddButton.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  DeleteConfirmationMsg.BeforeLoadDFMValues;
  EssentialsTable.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  try
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 185;
    lbPaginationInfo.Top := 32;
    lbPaginationInfo.Width := 112;
    lbPaginationInfo.Height := 15;
    lbPaginationInfo.Caption := 'No records to display';
    lbPaginationInfo.ElementFont := efCSS;
    lbPaginationInfo.ElementPosition := epIgnore;
    lbPaginationInfo.HeightStyle := ssAuto;
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthStyle := ssAuto;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    AddButton.SetParentComponent(Self);
    AddButton.Name := 'AddButton';
    AddButton.Left := 72;
    AddButton.Top := 296;
    AddButton.Width := 96;
    AddButton.Height := 25;
    AddButton.Caption := 'Add';
    AddButton.ChildOrder := 7;
    AddButton.ElementClassName := 'btn btn-light';
    AddButton.ElementFont := efCSS;
    AddButton.ElementPosition := epIgnore;
    AddButton.HeightStyle := ssAuto;
    AddButton.HeightPercent := 100.000000000000000000;
    AddButton.WidthStyle := ssAuto;
    AddButton.WidthPercent := 100.000000000000000000;
    SetEvent(AddButton, Self, 'OnClick', 'AddButtonClick');
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 33;
    cbPageSize.Top := 29;
    cbPageSize.Width := 81;
    cbPageSize.Height := 23;
    cbPageSize.ElementClassName := 'form-select';
    cbPageSize.ElementFont := efCSS;
    cbPageSize.ElementPosition := epIgnore;
    cbPageSize.HeightStyle := ssAuto;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.Text := '10';
    cbPageSize.WidthStyle := ssAuto;
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    DeleteConfirmationMsg.SetParentComponent(Self);
    DeleteConfirmationMsg.Name := 'DeleteConfirmationMsg';
    DeleteConfirmationMsg.Left := 33;
    DeleteConfirmationMsg.Top := 252;
    DeleteConfirmationMsg.Width := 24;
    DeleteConfirmationMsg.Height := 24;
    DeleteConfirmationMsg.ElementClassName := 'PopUpForm';
    DeleteConfirmationMsg.Buttons := [];
    DeleteConfirmationMsg.Opacity := 0.200000000000000000;
    DeleteConfirmationMsg.Title := 'Delete';
    EssentialsTable.SetParentComponent(Self);
    EssentialsTable.Name := 'EssentialsTable';
    EssentialsTable.Left := 72;
    EssentialsTable.Top := 83;
    EssentialsTable.Width := 505;
    EssentialsTable.Height := 193;
    EssentialsTable.HeightStyle := ssAuto;
    EssentialsTable.WidthStyle := ssAuto;
    EssentialsTable.BorderColor := clSilver;
    EssentialsTable.ChildOrder := 3;
    EssentialsTable.ElementFont := efCSS;
    EssentialsTable.ElementHeaderClassName := 'thead-light';
    EssentialsTable.ElementPosition := epIgnore;
    EssentialsTable.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    EssentialsTable.Footer.ButtonActiveElementClassName := 'btn btn-primary';
    EssentialsTable.Footer.ButtonElementClassName := 'btn btn-light';
    EssentialsTable.Footer.DropDownElementClassName := 'form-control';
    EssentialsTable.Footer.InputElementClassName := 'form-control';
    EssentialsTable.Footer.LinkActiveElementClassName := 'link-primary';
    EssentialsTable.Footer.LinkElementClassName := 'link-secondary';
    EssentialsTable.Footer.ListElementClassName := 'pagination';
    EssentialsTable.Footer.ListItemElementClassName := 'page-item';
    EssentialsTable.Footer.ListLinkElementClassName := 'page-link';
    EssentialsTable.Header.ButtonActiveElementClassName := 'btn btn-primary';
    EssentialsTable.Header.ButtonElementClassName := 'btn btn-light';
    EssentialsTable.Header.DropDownElementClassName := 'form-control';
    EssentialsTable.Header.InputElementClassName := 'form-control';
    EssentialsTable.Header.LinkActiveElementClassName := 'link-primary';
    EssentialsTable.Header.LinkElementClassName := 'link-secondary';
    EssentialsTable.Header.ListElementClassName := 'pagination';
    EssentialsTable.Header.ListItemElementClassName := 'page-item';
    EssentialsTable.Header.ListLinkElementClassName := 'page-link';
    SetEvent(EssentialsTable, Self, 'OnGetCellChildren', 'EssentialsTableGetCellChildren');
    EssentialsTable.Columns.Clear;
    with EssentialsTable.Columns.Add do
    begin
      DataField := 'EntityClassName';
      Title := 'Entity';
    end;
    with EssentialsTable.Columns.Add do
    begin
      DataField := 'FieldName';
      Title := 'Field';
    end;
    with EssentialsTable.Columns.Add do
    begin
      Title := 'Actions';
    end;
    EssentialsTable.DataSource := DataSource;
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 153;
    lcPaginator.Top := 354;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightStyle := ssAuto;
    lcPaginator.WidthStyle := ssAuto;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.ChildOrder := 3;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementFont := efCSS;
    lcPaginator.ElementPosition := epIgnore;
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Items.Clear;
    with lcPaginator.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with lcPaginator.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with lcPaginator.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    lcPaginator.Style := lsPagination;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    SetEvent(DataSource, Self, 'OnDataChange', 'DataSourceDataChange');
    DataSource.Left := 528;
    DataSource.Top := 288;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    AddButton.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    DeleteConfirmationMsg.AfterLoadDFMValues;
    EssentialsTable.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
  end;
end;

end.
